import { useContext } from 'react';
import { SiteAuthContext } from '../context/siteAuthContext';

export function useSiteAuth() {
  const context = useContext(SiteAuthContext);

  if (!context) {
    throw new Error('useSiteAuth must be used inside SiteAuthProvider');
  }

  return context;
}
